<template>
  <div class="fixed h-full w-full bg-white z-50 items-center justify-center bg-opacity-60 top-0 left-0" :class="loading ? 'flex' : 'hidden'">
    <VueSpinner size="40" color="#2563eb" />
  </div>
  <div id="cnc-app">
    <div class="flex justify-between items-center h-16">
      <h2 class="text-3xl font-bold">Online Anmeldung</h2>
      <div class="flex gap-2 items-center">
        <div v-if="isDev" class="flex justify-between">
          <div></div>
          <input type="button" class="button dev" value="Reset State" @click="reset"/>
        </div>
        <span class="text-slate-200">{{ refFromStore }}</span>
      </div>
    </div>
    <MainStepsTracker/>
    <div class="line-with-text mt-8 mb-14 opacity-30">
      <span>Bitte fülle nachfolgende Felder aus oder triff deine Auswahl</span>
    </div>

    <div v-if="currentStep === DetailStep.VORAUSWAHL_START">
      <VorauswahlStart/>
    </div>
    <div v-else-if="currentStep === DetailStep.VORAUSWAHL_FREIWILLIG">
      <VorauswahlFreiwillig/>
    </div>
    <div v-else-if="currentStep === DetailStep.VORAUSWAHL_FÜHRERSCHEIN">
      <VorauswahlFührerschein/>
    </div>
    <div v-else-if="currentStep === DetailStep.VORAUSWAHL_FÜHRERSCHEIN_DATEN">
      <VorauswahlFührerscheinDaten/>
    </div>
    <div v-else-if="currentStep === DetailStep.FAHRZEUGTYP">
      <FahrzeugTyp/>
    </div>
    <div v-else-if="currentStep === DetailStep.FÜHRERSCHEINKLASSEN">
      <FührerscheinKlassen/>
    </div>
    <div v-else-if="currentStep === DetailStep.TERMIN">
      <TerminStepFührerschein v-if="isFührerschein"></TerminStepFührerschein>
      <TerminStepTraining v-else></TerminStepTraining>
    </div>
    <div v-else-if="currentStep === DetailStep.TERMIN_LEIHFAHRZEUG">
      <TerminStepTrainingLeihfahrzeug/>
    </div>
    <div v-else-if="currentStep === DetailStep.TERMIN_STANDORT">
      <TerminStepLocation/>
    </div>
    <div v-else-if="currentStep === DetailStep.PERSÖNLICHEDATEN">
      <PersönlicheDaten/>
    </div>
    <div v-else-if="currentStep === DetailStep.ÜBERPRÜFEN">
      <UeberprüfenStep/>
    </div>
    <div v-else-if="currentStep === DetailStep.DONE">
      <DoneStep/>
    </div>
  </div>
</template>

<script setup>
import VorauswahlStart from './tabs/vorauswahl/VorauswahlStart.vue';
import VorauswahlFreiwillig from './tabs/vorauswahl/VorauswahlFreiwillig.vue';
import VorauswahlFührerschein from './tabs/vorauswahl/VorauswahlFuehrerschein.vue';
import VorauswahlFührerscheinDaten from './tabs/vorauswahl/VorauswahlFuehrerscheinDaten.vue';
import FührerscheinKlassen from './tabs/FührerscheinKlassen.vue';
import FahrzeugTyp from './tabs/FahrzeugTyp.vue';
import TerminStepFührerschein from './tabs/termin/TerminStepFuehrerschein.vue';
import TerminStepTraining from './tabs/termin/TerminStepTraining.vue';
import TerminStepTrainingLeihfahrzeug from './tabs/termin/TerminStepTrainingLeihfahrzeug.vue';
import PersönlicheDaten from './tabs/PersoenlicheDaten.vue';
import UeberprüfenStep from './tabs/UeberpruefenStep.vue';
import DoneStep from './tabs/DoneStep.vue';
import MainStepsTracker from './components/MainStepsTracker.vue';
import { DetailStep } from './models/enums';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { VueSpinner } from 'vue3-spinners';
import TerminStepLocation from './tabs/termin/TerminStepLocation.vue';

const store = useStore();
const currentStep = computed(() => store.state.currentStep);
const isFührerschein = computed(() => store.getters.IS_FÜHRERSCHEIN);
const loading = computed(() => store.state.loading);
const isDev = store.state.isDev;
const reset = () => store.commit("resetState");
const url = new URL(window.location.href);
const ref = (new URLSearchParams(url.search))?.get('ref');

store.commit("updateRef", ref);

const refFromStore = computed(() => store.state.ref);
</script>

<style lang="scss"></style>
